import { Report1910 } from "../../../components/borrowSystem/Report/Report1910";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";

export function Report1910Container() {
  const titleName = "ตารางสรุปการค้างชำระเงินกู้ยืม ";
  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <Report1910 />
      <Footer />
    </div>
  );
}
